<template>
  <div
    class="main-chooseattribute row no-margin"
    style="height: 100%;">

    <header class="row align-items-center no-margin">
      <div class="col">
        <button
          class="btn no-bg"
          @click="onClickBack()">
          <i class="fas fa-times"/>
        </button>
      </div>
      <div class="col text-center">
        {{ product.product_name }}
      </div>
      <div class="col text-right">
        <button
          class="btn no-bg"
          @click="onClickDone()">
          <i class="fas fa-check"/>
        </button>
      </div>
    </header>

    <div
      class="row main col-md-12 col-lg-8"
      style="height: 100%;overflow: auto;">
      <div class="wall"/>
      <div class="col-6">
        <div class="col-12 no-padding">
          <div class="col no-padding mt-4 mb-1">
            {{ $t('message.chooseone') }}
          </div>
          <ul :class="['wrapper-items', {'is-invalid': isInvalid}]">
            <li
              v-for="(item, index) in product.prices"
              :key="index"
              :class="['row no-margin item fixed-layout', {'disabled': isNotAvailable(item) || isOutOfStock(item)}]"
            >
              <vs-radio
                v-model="radioSkuId"
                :disabled="isNotAvailable(item) || isOutOfStock(item)"
                :vsValue="item.sku_id"
                color="#A3CA76"
                @change="handleSkuIdChange"
              />
              <div class="name">
                <p class="limit-line">
                  <template v-for="(attr, index) in item.attributes">
                    <span
                      v-if="stockCount(product, item.sku_id)"
                      class="badge badge-secondary"
                      style="font-size: 12px;position: relative; top: 0px;"
                    >
                      <i
                        class="fas fa-box-open"
                        style="font-size: 12px;position: relative; top: 1px;"/>
                      {{ stockCount(product, item.sku_id) }}
                    </span>
                    <span
                      class="_name"
                      style="font-size: 9px;">
                      {{ attr.name }}
                    </span>
                    <span class="_name">
                      {{ attr.option }}
                      <template v-if="index < item.attributes.length-1">, </template>
                    </span>
                  </template>
                  <span
                    v-if="isNotAvailable(item)"
                    class="badge badge-danger"
                    style="font-size: 9px;position: relative;top: -1px;"
                  >
                    {{ $t('message.productisnotavailable') }}
                  </span>
                  <span
                    v-if="isOutOfStock(item)"
                    class="badge badge-danger"
                    style="font-size: 9px;position: relative;top: -1px;"
                  >
                    {{ $t('message.outofstock') }}
                  </span>
                </p>
              </div>
              <div class="text-right price">
                <span style="float: right;">
                  {{ getNumber(item.price) || $t('message.variable') }}
                </span>
                <!-- Custom Price -->
                <vs-tooltip
                  v-if="isCustomPrice(item.sku_id)"
                  :text="$t('message.customprice').toLowerCase()"
                  position="top"
                  style="float: right;margin-right: 6px;cursor: pointer;"
                >
                  <span
                    class="badge badge-secondary"
                    style="height: 15px; display: flex; align-items: center; justify-content: center; font-size: 9px; position: relative; top: 4px;"
                  >
                    <i
                      class="fas fa-calculator"
                      style="font-size: 10px; top: 0px;"/>
                  </span>
                </vs-tooltip>
                <!-- Lot -->
                <vs-tooltip
                  v-if="isProductUseLot(item)"
                  :text="$t('message.chooselot').toLowerCase()"
                  position="top"
                  style="float: right;margin-right: 6px;cursor: pointer;"
                >
                  <span
                    class="badge badge-secondary"
                    style="height: 15px; display: flex; align-items: center; justify-content: center; font-size: 9px; position: relative; top: 4px;"
                  >
                    <i
                      class="fas fa-pallet"
                      style="font-size: 10px; top: 0px;"/>
                  </span>
                </vs-tooltip>
                <!-- Serial -->
                <vs-tooltip
                  v-if="isProductUseSerial(item)"
                  :text="$t('message.chooselot').toLowerCase()"
                  position="top"
                  style="float: right;margin-right: 6px;cursor: pointer;"
                >
                  <span
                    class="badge badge-secondary"
                    style="height: 15px; display: flex; align-items: center; justify-content: center; font-size: 9px; position: relative; top: 4px;"
                  >
                    <i
                      class="fas fa-sd-card"
                      style="font-size: 10px; top: 0px;"/>
                  </span>
                </vs-tooltip>
              </div>
              <div
                v-if="(isSelectedLot && radioSkuId === item.sku_id) || (isProductUseLot(item) && product.prices.length === 1)"
                class="col-12"
              >
                <div class="row m-0">
                  <div
                    v-for="(lotItem, lotIndex) in lot.selected"
                    :key="lotIndex"
                    class="col-12 no-padding mt-1"
                  >
                    <div
                      class="outer-modifier row"
                      style="color: #BBBBBB;font-size: 14px;">
                      <div class="col-8 name">
                        <strong>
                          {{ lotItem.lotCode }}
                          <i
                            class="fas fa-pallet"
                            style="font-size: 12px;position: relative;top: -1px;"/>
                        </strong>
                      </div>
                      <div class="col-4 price text-right">
                        {{ lotItem.unit }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-12">
                    <BaseButton
                      className="btn-sm"
                      @click="onClickOpenLotModal"
                    >
                      {{ $t('apps.inventory.button.selectlotnumber') }}
                    </BaseButton>
                  </div>
                </div>
              </div>
              <div
                v-if="(isSelectedSerial && radioSkuId === item.sku_id) || (isProductUseSerial(item) && product.prices.length === 1)"
                class="col-12"
              >
                <div class="row m-0">
                  <div
                    v-for="(serialItem, serialIndex) in serial.selected"
                    :key="serialIndex"
                    class="col-12 no-padding mt-1"
                  >
                    <div
                      class="outer-modifier row"
                      style="color: #BBBBBB;font-size: 14px;">
                      <div class="col-8 name">
                        <strong>
                          {{ serialItem.serCode }}
                          <i
                            class="fas fa-sd-card"
                            style="font-size: 12px;position: relative;top: -1px;"/>
                        </strong>
                      </div>
                      <div class="col-4 price text-right">
                        {{ serialItem.unit }}
                      </div>
                      <div
                        class="col-12"
                        style="font-size: 11px;">
                        {{ serialItem.serialNumber }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-12">
                    <BaseButton
                      className="btn-sm"
                      @click="onClickOpenSerialModal"
                    >
                      {{ $t('apps.inventory.button.selectserialnumber') }}
                    </BaseButton>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div
          v-for="(item, index) in mapProductModifiers"
          :key="index"
          class="col-12 no-padding"
        >
          <div class="col no-padding mt-4 mb-1">
            <!-- Modifier CHOOSE UP TO 2 -->
            {{ item.modifier_name }}
            <span
              v-if="getModifierHelperText($t, item).length"
              :class="[
                item.isInvalid ? 'text-danger' : 'text-gray'
            ]">
              {{ getModifierHelperText($t, item) }}
            </span>
          </div>
          <ul
            :class="[
              {
                'is-invalid': item.isInvalid
              }
            ]"
            class="wrapper-items">
            <li
              v-for="(item_, index_) in item.options"
              :key="index_"
              :class="[
                { 'disabled': item_.disabled }
              ]"
              class="row no-margin item fixed-layout">
              <vs-checkbox
                v-model="checkBoxModifierOptionIds"
                :vsValue="item_.modifieroption_id"
                :disabled="item_.disabled"
                color="#A3CA76"/>
              <div class="name">
                <p class="limit-line">
                  {{ item_.option }}
                </p>
              </div>
              <div class="text-right price">
                {{ getNumber(item_.price) }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-6">
        <div
          v-if="discounts.length > 0"
          class="col-12 no-padding">
          <div class="col no-padding mt-4 mb-1 text-uppercase">
            {{ $t('message.discounts') }}
          </div>
          <ul class="wrapper-items">
            <li
              v-for="(item, index) in discounts"
              :class="['row', 'no-margin', 'item', item.type]"
            >
              <div class="col-8 name">
                {{ item.discount_name }}
                <span>
                  {{ item.amountText }}
                </span>
              </div>
              <div class="col-4 text-right price">
                <vs-switch
                  v-if="!useBarcodeScanner"
                  v-model="switchDiscountIds[index]"
                  :disabled="item.type === 'conditional'"
                  style="float: right;margin: 0 0 0 10px;"
                  color="#A3CA76"
                  vsType="success"
                />
                <Tooltip
                  v-if="item.type === 'conditional'"
                  style="float: right;"
                  position="bottom"
                >
                  <span
                    class="badge badge-secondary"
                    style="position: relative;top: 2px;max-width: 80px;overflow: hidden;"
                  >
                    {{ $t('message.conditional') }}
                  </span>
                  <template v-slot:message>
                    <div
                      v-for="(text) in item.tooltipTexts"
                      class="alert alert-secondary text-left"
                    >
                      {{ text }}
                    </div>
                  </template>
                </Tooltip>
              </div>
            </li>
            <!-- <li class="row no-margin item">
              <div class="col-8 name">
                Custom
              </div>
              <div class="col-4 text-right price">

              </div>
            </li> -->
          </ul>
        </div>
        <div
          v-if="taxes.length > 0"
          class="col-12 no-padding">
          <div class="col no-padding mt-4 mb-1 text-uppercase">
            {{ $t('message.taxes') }}
          </div>
          <ul class="wrapper-items">
            <li
              v-for="(item, index) in taxes"
              class="row no-margin item">
              <div class="col-8 name">
                {{ item.tax_name }} {{ item.amount }}%
              </div>
              <div class="col-4 text-right price">
                <vs-switch
                  v-if="!useBarcodeScanner"
                  v-model="switchTaxIds[index]"
                  style="float: right;
                                  margin: 0;"
                  vsType="success"
                  color="#A3CA76"/>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-12 no-padding">
          <div class="col no-padding mt-4 mb-1 text-uppercase">
            {{ $t('message.noteandquantity') }}
          </div>
          <ul class="wrapper-items">
            <li
              class="row no-margin item"
              style="background: none;
                                                  border: none;
                                                  cursor: default;
                                                  padding-bottom: 0;">
              <div class="col-7 name no-padding">
                <input
                  v-model="note"
                  :placeholder="$t('placeholder.addnote')"
                  class="form-control"
                  style="height: 40px;border: solid 1px #D8E2E7;border-right: none;border-radius: 0;"
                >
              </div>
              <div
                class="col-5 text-right price"
                style="padding-right: 0;">
                <BaseVsInputNumber
                  ref="quantity"
                  v-model="quantity"
                  :disabled="!!isSelectedLot || !!isSelectedSerial"
                  color="#A3CA76"
                  min="1"
                  class="custom-vs-input-number"
                  @click="selectedInputQuantity"
                />
                <!-- <vs-input-number
                  v-model="quantity"
                  ref="quantity"
                  :disabled="!!isSelectedLot || !!isSelectedSerial"
                  color="#A3CA76"
                  min="1"
                  class="custom-vs-input-number"
                  @click="selectedInputQuantity"
                /> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Modal Select Lot Number -->
    <BaseSelectLotNumberModal
      :show="lotModal.show"
      :loading="lotModal.loading"
      :lots="lotList"
      :selected="lot.selected"
      :index="0"
      :skuId="lot.skuId"
      @onClose="handleCloseLotModal"
      @onCancel="handleCancleLotModal"
      @onSubmit="handleSumitLotModal"
      @onSortChange="handleSortLotChange"
    />

    <!-- Modal Select Serial Number -->
    <BaseSelectSerialNumberModal
      :show="serialModal.show"
      :loading="serialModal.loading"
      :serials="serialList"
      :selected="serial.selected"
      :index="0"
      :skuId="serial.skuId"
      @onClose="handleCloseSerialModal"
      @onCancel="handleCancleSerialModal"
      @onSubmit="handleSumitSerialModal"
      @onSortChange="handleSortSerialChange"
    />
  </div>
</template>

<script>
import posSelectLotMixin from '@/mixins/posSelectLot'
import posSelectSerialMixin from '@/mixins/posSelectSerial'
import chooseAttributeMixin from '@/mixins/pos/chooseAttribute'

export default {
  mixins: [posSelectLotMixin, posSelectSerialMixin, chooseAttributeMixin],
}
</script>

<style scoped>
  .main {
    margin: auto;
    position: relative;
  }
  .main .wall {
    position: absolute;
    width: 1px;
    height: -webkit-calc(100% - 1.5rem);
  	height:    -moz-calc(100% - 1.5rem);
  	height:         calc(100% - 1.5rem);
    left: -webkit-calc(50% - 0.5px);
  	left:    -moz-calc(50% - 0.5px);
  	left:         calc(50% - 0.5px);
    top: 1.5rem;
    background: #D8E2E7;
  }
  .main ul.wrapper-items {
    margin: 0;
  }
  .main ul.wrapper-items li.item {
    background: #FFF;
    border-bottom: solid 1px #D8E2E7;
    padding: 8px 0;
    position: relative;
  }
  .main ul.wrapper-items li.item.fixed-layout {
    background: #FFF;
    border-bottom: solid 1px #D8E2E7;
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 8px 15px;
  }
  .main ul.wrapper-items li.item.disabled ._name,
  .main ul.wrapper-items li.item.disabled .name,
  .main ul.wrapper-items li.item.disabled .price {
    opacity: .5;
  }
  .main ul.wrapper-items li.item .con-vs-checkbox, .main ul.wrapper-items li.item .con-vs-radio {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    margin: 0;
  	width: calc(100%);
  	height: 40px;
    cursor: pointer;
  }

  .main ul.wrapper-items li.item i {
    font-size: 18px;
    position: relative;
    top: 2px;
  }
  .main ul.wrapper-items li.item .name {
    padding-right: 0;
  }
  .main ul.wrapper-items.is-invalid {
    box-shadow: 0 0 0 1px #dc3545;
  }
  .main ul.wrapper-items li.item .price {
    padding-left: 0;
  }
  .vs-input-number input {
    width: 50% !important;
  }
  .limit-line {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    height: auto;
    white-space: nowrap;
    margin: 0;
    padding-left: 30px;
  }
  .alert-secondary {
    width: 100%;
    padding: 8px;
    font-size: 12px;
    margin-bottom: 8px;
  }
  .alert-secondary:last-of-type {
    margin-bottom: 0;
  }
  .custom-vs-input-number /deep/ .vs-input-number {
    padding: 0px;
    margin: 0px;
    background: #fff;
    border: solid 1px #D8E2E7;
    width: 100%;
    height: 40px;
    border-radius: 0;
  }
</style>

<style>
  #main-pos .main-chooseattribute .wrapper-items .vs-radio {
    position: absolute;
    left: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/main/include/ChooseAttribute.vue